import {
    ROOT,
    GET_ALL_SERVICE_COMBO,
    DELETE_SERVICE_STATIC,
    UPDATE_STATUS_SERVICE_STATIC,
    DETAIL_SERVICE_STATIC,
    CHECK_SERVICE_CODE_STATIC,
    CREATE_SERVICE_STATIC,
    UPDATE_SERVICE_STATIC,
    GET_ROOM_RATE_PACKAGE,
    CREATE_ROOM_RATE_PACKAGE,
    REMOVE_ROOM_RATE_PACKAGE,
    CREATE_ROOM_RATE_PACKAGE_LIST,
    UPDATE_ROOM_RATE_PACKAGE_LIST,
    ROOM_RATE_PAACKAGE_WEEKLY,
    ROOM_RATE_PACKAGE_DAILY,
    UPDATE_ROOM_RATE_PACKAGE_LIST_DAILY,
    ROOM_RATE_PACKAGE_SPECIAL
  } from '@/_helpers/constant.js';
  import { requestOptions, handleResponse } from '@/_helpers';
  
  function getAllService() {
    return fetch(ROOT + GET_ALL_SERVICE_COMBO, requestOptions.get())
      .then(handleResponse);
  }

  function deleteService(id) {
    return fetch(ROOT + DELETE_SERVICE_STATIC + `/${id}`, requestOptions.get())
      .then(handleResponse)
      .then(data => {
        return data;
      });
  }
  function updateStatus(id) {
    return fetch(ROOT + UPDATE_STATUS_SERVICE_STATIC + `/${id}`, requestOptions.get())
      .then(handleResponse)
      .then(data => {
        return data;
      });
  }

  function getDetailService(id) {
    return fetch(ROOT + DETAIL_SERVICE_STATIC + `/${id}`, requestOptions.get())
      .then(handleResponse)
      .then(data => {
        return data;
      });
  }

  function updateService(body) {
    return fetch(ROOT + UPDATE_SERVICE_STATIC, requestOptions.post(body))
      .then(handleResponse)
      .then(data => {
        return data;
      });
  }
  
  function createService(body) {
    return fetch(ROOT + CREATE_SERVICE_STATIC, requestOptions.post(body))
      .then(handleResponse)
      .then(data => {
        return data;
      });
  }
  
  function checkServiceCode(code) {
    return fetch(ROOT + CHECK_SERVICE_CODE_STATIC + `/${code}`, requestOptions.get())
      .then(handleResponse)
      .then(data => {
        return data;
      });
  }

  function getRoomRatePackage() {
    return fetch(ROOT + GET_ROOM_RATE_PACKAGE, requestOptions.get())
      .then(handleResponse)
      .then(data => {
        return data;
      });
  }

  function creatRoomRatePackage(data) {
    return fetch(ROOT + CREATE_ROOM_RATE_PACKAGE, requestOptions.post(data))
      .then(handleResponse)
      .then(data => {
        return data;
      });
  }

  function removeServiceRoomRate(data) {
    return fetch(ROOT + REMOVE_ROOM_RATE_PACKAGE + `/${data}`, requestOptions.get())
      .then(handleResponse)
      .then(data => {
        return data;
      });
  }

  function creatRoomRatePackageList(data) {
    return fetch(ROOT + CREATE_ROOM_RATE_PACKAGE_LIST, requestOptions.post(data))
      .then(handleResponse)
      .then(data => {
        return data;
      });
  }

  function updateRoomRatePackageList(data) {
    return fetch(ROOT + UPDATE_ROOM_RATE_PACKAGE_LIST, requestOptions.post(data))
      .then(handleResponse)
      .then(data => {
        return data;
      });
  }

  function getRoomRatePackageWeekly(data) {
    return fetch(ROOT + ROOM_RATE_PAACKAGE_WEEKLY+ `/${data}`, requestOptions.get())
      .then(handleResponse)
      .then(data => {
        return data;
      });
  }

  function getRoomRatePackageDaily() {
    return fetch(ROOT + ROOM_RATE_PACKAGE_DAILY, requestOptions.get())
      .then(handleResponse)
      .then(data => {
        return data;
      });
  }

  function updateRoomRatePackageListDaily(data) {
    return fetch(ROOT + UPDATE_ROOM_RATE_PACKAGE_LIST_DAILY, requestOptions.post(data))
      .then(handleResponse)
      .then(data => {
        return data;
      });
  }

  function getRoomRatePackageSpecial() {
    return fetch(ROOT + ROOM_RATE_PACKAGE_SPECIAL, requestOptions.get())
      .then(handleResponse)
      .then(data => {
        return data;
      });
  }
  
  export const serviceCombo = {
    getAllService,
    deleteService,
    updateStatus,
    getDetailService,
    updateService,
    createService,
    checkServiceCode,
    getRoomRatePackage,
    creatRoomRatePackage,
    removeServiceRoomRate,
    creatRoomRatePackageList,
    updateRoomRatePackageList,
    getRoomRatePackageWeekly,
    getRoomRatePackageDaily,
    updateRoomRatePackageListDaily,
    getRoomRatePackageSpecial
  };